/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  List,
  Form,
  Spin,
  message,
  Carousel,
  Tooltip,
  Radio,
  Text,
  Tabs,
  Modal,
} from "antd";

import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { LeftOutlined, RightOutlined, PaperClipOutlined } from "@ant-design/icons";

import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { useCopilotReadable } from "@copilotkit/react-core";

import "./index.scss";
import dashboardAnnouncementIcone from "../../assests/images/dashboard-annonsment.svg";
import dashbordMessageIcon from "../../assests/images/dashbord-message-icon.svg";
import accountBookingArrowIcon from "../../assests/images/arrow.svg";
import calenderIcon from "../../assests/images/calenderIcon.svg";
import attachmentIcon from "../../assests/images/paperpin.svg";

import { dashboardMenuList } from "../../config/dashboard";
import DashbordCard from "./DashbordCard";
import constants from "../../constants/messages";
import roleConstants from "../../constants/constants";
const { ROLES } = roleConstants;
const {
  CP_ADMIN,
  HO_ADMIN,
  HUB_ADMIN,
  ROLE_HOMARKETING,
  ROLE_ZONALHEAD,
  ROLE_ZONALOPERATOR,
  ROLE_RM,
  ROLE_FUNCTIONALHEAD,
  ROLE_MD,
  ROLE_CENTRALOPERATOR,
  ROLE_BOOKINGAUDITONLY,
  ROLE_HUBOPERATOR,
  DEVELOPER,
  CUSTOMER_DELIGHT_EXECUTIVE,
  ROLE_CSO,
  ROLE_HOCRM,
  ROLE_HO_CRM_CP
} = ROLES;
import { getAccountService } from "../../actionsMethods/cashBookingMethods";
import { APIs, getToken, getPremiseId } from "../../utils/worker";
import axios from "axios";
import API from "../../api";
import { ReloadOutlined } from "@ant-design/icons";
import moment from "moment";
import nodeURLs from "../../api/nodeUrls";
import { capitalize, showErrorMessage } from "../../utils";
import urls from "../../api/urls";
import { LiveTickets, TicketDetail } from "hubops-live-ticket-component";
import "hubops-live-ticket-component/dist/style.css";

const premiseId = getPremiseId();
const { SHIPMENT_COUNT, DASHBOARD_COUNT } = nodeURLs;
const { DASHBOARD_COUNT_NEW } = urls;

const { TabPane } = Tabs;
function Dashboard() {
  const userinfo = JSON.parse(localStorage.getItem("userinfo") || "{}");
  const getRole = userinfo?.roles?.[0]?.replace(/.*_/, "");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { ANNOUNCEMENT } = constants;
  const { DASHBORD_SCANNED_UNSCANNED, GET_REGEX_PATTERN } = urls;

  const [form] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);

  const [accountDetails, setAccountDetails] = useState();
  const [day, setDay] = useState(1);
  const [onClickTime, setOnClickTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [todayData, setTodayData] = useState([]);
  const [activeTab, setActiveTab] = useState("hub");
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isAnnouncementModalVisible, setIsAnnouncementModalVisible] = useState(false);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

  // Make dashboard data available to CopilotKit
  useCopilotReadable({
    description: "Current dashboard data including shipment counts, user information, and operational metrics",
    value: {
      currentUser: {
        username: accountDetails?.username,
        role: getRole,
        roles: userinfo?.roles || [],
        premiseId: premiseId?.split("Bearer ")[1]
      },
      dashboardMetrics: {
        activeTab: activeTab,
        selectedDay: day,
        todayData: todayData,
        loading: loading
      },
      availableMenuItems: dashboardMenuList.filter(item =>
        item.role.some(role => userinfo?.roles?.includes(role))
      ).map(item => ({
        title: item.title,
        id: item.id,
        route: item.route
      })),
      announcements: dataSource?.length > 0 ? dataSource.map(announcement => ({
        title: announcement.title,
        content: announcement.content,
        date: announcement.createdDate
      })) : [],
      shipmentStatus: todayData ? {
        inbound: todayData.inbound || {},
        outbound: todayData.outbound || {},
        hubOperations: todayData.hubOperations || {}
      } : null,
      currentTime: day,
      lastUpdated: new Date().toISOString()
    }
  });

  // Make dashboard menu configuration available
  useCopilotReadable({
    description: "Dashboard menu configuration and available features based on user role",
    value: {
      userRole: getRole,
      availableFeatures: dashboardMenuList
        .filter(item => item.role.some(role => userinfo?.roles?.includes(role)))
        .map(item => ({
          name: item.title,
          id: item.id,
          route: item.route,
          description: `Navigate to ${item.title} section`
        })),
      roleBasedAccess: {
        canAccessBooking: userinfo?.roles?.includes(CP_ADMIN),
        canAccessHubOperations: userinfo?.roles?.includes(HUB_ADMIN) || userinfo?.roles?.includes(ROLE_HUBOPERATOR),
        canAccessReports: userinfo?.roles?.some(role =>
          [HUB_ADMIN, HO_ADMIN, ROLE_ZONALHEAD, ROLE_ZONALOPERATOR, ROLE_RM, ROLE_FUNCTIONALHEAD, ROLE_MD, ROLE_CENTRALOPERATOR, ROLE_BOOKINGAUDITONLY, ROLE_HUBOPERATOR, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP].includes(role)
        ),
        canAccessMasterSettings: userinfo?.roles?.some(role =>
          [HO_ADMIN, HUB_ADMIN, DEVELOPER, ROLE_HOCRM, ROLE_HO_CRM_CP].includes(role)
        )
      }
    }
  });

  // Make operational data available
  useCopilotReadable({
    description: "Real-time operational data and shipment tracking information",
    value: {
      operationalData: todayData ? {
        inboundShipments: {
          incoming: todayData.inbound?.incoming || 0,
          inscan: todayData.inbound?.inscan || 0,
          pending: todayData.inbound?.pending || 0,
          total: (todayData.inbound?.incoming || 0) + (todayData.inbound?.inscan || 0) + (todayData.inbound?.pending || 0)
        },
        outboundShipments: {
          outscan: todayData.outbound?.outscan || 0,
          pending: todayData.outbound?.pending || 0,
          total: (todayData.outbound?.outscan || 0) + (todayData.outbound?.pending || 0)
        },
        summary: {
          totalInbound: (todayData.inbound?.incoming || 0) + (todayData.inbound?.inscan || 0) + (todayData.inbound?.pending || 0),
          totalOutbound: (todayData.outbound?.outscan || 0) + (todayData.outbound?.pending || 0),
          totalPending: (todayData.inbound?.pending || 0) + (todayData.outbound?.pending || 0)
        }
      } : null,
      dataFreshness: {
        lastRefresh: new Date().toISOString(),
        selectedPeriod: day,
        isLoading: loading
      }
    }
  });

  useEffect(() => {
    //initialize();
    getRegexPattern();
  }, []);
  const getpremiseResponse = useSelector(
    (state) => state?.appReducer?.getCpPremiseReducer,
    shallowEqual
  );

  const { fetching, result } = getpremiseResponse;

  useEffect(() => {
    if (!fetching) {
      localStorage.setItem(
        "permises",
        JSON.stringify(result, getpremiseResponse?.result?.premises?.stateCode)
      );
    }
  }, [getpremiseResponse]);

  function getDate(day = "today") {
    const date = new Date();
    setDay(`${moment().format("hh:mm a")}  ${day}`);
    if (day === "yesterday") {
      setDay(day);
      // setOnClickTime(day);
      date.setDate(date.getDate() - 1);
    }

    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  }

  useEffect(() => {
    navigate("/dashboard", { state: { test: "test" } });

    if (
      getRole === "HUBADMIN" ||
      getRole === "HUBOPERATOR" ||
      getRole === "DEVELOPER"
    ) {
      getTodaysData("today");
    }
    setAccountDetails(JSON.parse(localStorage.getItem("userinfo")));
    getAnnouncements();
  }, []);

  useEffect(() => {
    if (accountDetails !== undefined) {
      dispatch(getAccountService(accountDetails?.username));
    }
  }, [accountDetails]);

  const getTodaysData = async (day) => {
    let dates = getDate(day);
    getScannedAndUnscanned(dates);
    // setLoading(true);
    // let dates = getDate(day);

    // const response = await API.Api(
    //   `${DASHBORD_SCANNED_UNSCANNED}`
    // ).getWithPremiseHeader();

    // if (response?.status) {
    //   let parentData = response.response.data;

    //   getScannedAndUnscanned(dates, parentData);
    // } else {
    //   setLoading(false);
    //   setTodayData([]);
    //   message.config({ top: 80 });
    //   showErrorMessage(response?.statusText || "Internal server error");
    // }

    // setLoading(false);
  };
  const getRegexPattern = async () => {
    let response = await API.Api(GET_REGEX_PATTERN).getRegexPatternHeader();
    if (response.status) {
      console.log("API Response:", response?.response?.data);
      const pattern = response?.response?.data?.data?.configValue?.pattern;
      console.log("Pattern to store:", pattern);
      if (pattern) {
        localStorage.setItem("regexPattern", "");
        console.log("Stored in localStorage:", localStorage.getItem("regexPattern"));
      } else {
        console.error("No pattern found in response");
      }
    }
  };
  const getScannedAndUnscanned = async (date = null) => {
    setLoading(true);

    let activeHub = {};
    try {
      activeHub = JSON.parse(localStorage.getItem("active_hub"));
    } catch (e) {
      console.error("Error parsing active_hub", e);
    }

    const defaultPremiseId = premiseId?.split("Bearer ")[1];
    const effectivePremiseId = activeHub?.hubId || defaultPremiseId;

    const response = await API.Api(DASHBOARD_COUNT_NEW + "?date=" + date + "&premiseId=" + effectivePremiseId).getWithPremiseHeader();

    if (response?.status) {
      let data = response.response.data;
      // let obj = {
      //   inbound: {
      //     ...parentData?.inBound,
      //     ...data?.inbound,
      //   },
      //   outbound: {
      //     ...parentData?.outBound,
      //     ...data?.outbound,
      //   },
      // };
      setTodayData(data);
      console.log("Today Data:", data);
    } else {
      setLoading(false);
      setTodayData([]);
      message.config({ top: 80 });
      showErrorMessage(response?.statusText || "Internal server error");
    }

    setLoading(false);
  };

  const getAnnouncements = async () => {
    try {
      let response = await axios.get(
        `${APIs.baseURL}/broadcast-service/v1/broadcasts/show`,
        {
          headers: {
            Authorization: getToken(),
            token: getToken()?.split("Bearer ")[1],
            "SMCS-PREMISE-ID": premiseId?.split("Bearer ")[1],
          },
        }
      );
      if (response?.status == 200) {
        console.log("Announcements Data:", response.data);
        setDataSource(response?.data);
      }
    } catch (error) {
      message.config({ top: 80 });
      showErrorMessage(error?.response?.data?.message);
    }
  };

  const isVideo = (url) => {
    if (!url) return false;
    return url.match(/\.(mp4|webm|ogg|mov|avi)(\?|#|$)/i);
  };

  const isImage = (url) => {
    if (!url) return false;
    return url.match(/\.(jpeg|jpg|gif|png|webp)(\?|#|$)/i);
  };

  const isPdf = (url) => {
    if (!url) return false;
    return url.match(/\.pdf(\?|#|$)/i);
  };

  const getFileName = (url) => {
    if (!url) return "";
    const parts = url.split("/");
    const name = parts[parts.length - 1].split("?")[0];
    return decodeURIComponent(name);
  };

  const cleanHtml = (html) => {
    if (!html) return "";
    return html.replace(/(<br\s*\/?>|&nbsp;|\s)+$/gi, "").replace(/<p>(&nbsp;|\s)*<\/p>$/gi, "");
  };

  const getAttachmentUrl = (record) => {
    let url = record?.filePath ||
      record?.file ||
      record?.fileUrl ||
      record?.file_path ||
      record?.attachmentUrl ||
      record?.attachment ||
      record?.mediaPath ||
      record?.media_path;

    if (!url && record?.message) {
      const srcMatch = record.message.match(/src=['"]([^'"]+)['"]/i);
      const hrefMatch = record.message.match(/href=['"]([^'"]+)['"]/i);
      url = srcMatch ? srcMatch[1] : (hrefMatch ? hrefMatch[1] : null);
    }
    return url;
  };

  const showAnnouncement = (item) => {
    setSelectedAnnouncement(item);
    setIsAnnouncementModalVisible(true);
  };

  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: "black",
          fontSize: "15px",
          lineHeight: "1.5715 ",
        }}
        onClick={onClick}
      >
        <RightOutlined />
      </div>
    );
  };

  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          color: "black",
          fontSize: "15px",
          lineHeight: "1.5715 ",
        }}
        onClick={onClick}
      >
        <LeftOutlined />
      </div>
    );
  };

  const settings = {
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const radioOnChange = (event) => {
    console.log(event);
  };

  return (
    <div className="dashboard-container">
      <Spin spinning={fetching}>
        <Form
          form={form}
          layout="vertical"
          // onFinish={onFinish}
          autoComplete="off"
        >
          <div className="dashboardHeading">Dashboard</div>

          <Row gutter={[32, 32]} className="dashboard-container-row">
            <Col
              className="dashboard-container-col"
              xl={16}
              lg={16}
              md={24}
              sm={24}
              xs={24}
            >
              {(getRole === "HUBADMIN" || getRole === "HUBOPERATOR" || getRole === "DEVELOPER") && (
                <Spin spinning={todayData === null}>
                  <Row>
                    <Col
                      xl={24}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      className="dashboard-container-col-innercol"
                    >
                      <Row>
                        <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                          <CustomTabs
                            className="pl-1"
                            activeTab={activeTab}
                            tabChange={(e) => setActiveTab(e)}
                          />
                        </Col>
                        <Col
                          xl={12}
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          className="flex-end p-1"
                        >
                          <Radio.Group
                            buttonStyle="solid"
                            // style={{ width: "20%" }}
                            defaultValue="today"
                            onChange={(e) => getTodaysData(e.target.value)}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              <Radio.Button
                                value="yesterday"
                                style={{ flex: 1, textAlign: "center" }}
                              >
                                Yesterday
                              </Radio.Button>
                              <Radio.Button
                                value="today"
                                style={{ flex: 1, textAlign: "center" }}
                              >
                                Today
                              </Radio.Button>
                            </div>
                          </Radio.Group>
                        </Col>
                      </Row>
                      <div className="dashboard-container-col-innercol-trackOrder">
                        <span
                          style={{ color: "green", fontSize: "13px" }}
                          className="dashboard-container-col-innercol-trackOrder-name"
                        >
                          {/* Shipment Status */}
                        </span>
                        <div style={{ color: "red", fontSize: "13px" }}>
                          Results as on&nbsp;{day}
                          {day !== "yesterday" ? (
                            <Tooltip title={"Reload"}>
                              <ReloadOutlined
                                // onClick={getCurrentTime}
                                onClick={() => getTodaysData("today")}
                                style={{
                                  fontSize: 18,
                                  paddingLeft: "10px",
                                  color: "black",
                                }}
                              />
                            </Tooltip>
                          ) : null}
                        </div>
                      </div>

                      <Spin spinning={loading}>
                        <div className="custom-carousel">
                          <StatusRow
                            title="Shipment Status"
                            status={{
                              incoming: todayData[activeTab]?.shipment_wise?.incoming,
                              inscan: todayData[activeTab]?.shipment_wise?.inscan,
                              outscan: todayData[activeTab]?.shipment_wise?.outscan,
                              pending: todayData[activeTab]?.shipment_wise?.pending,
                            }}
                          />
                          {/* {activeTab == "inbound" && ( */}
                          <StatusRow
                            title="Bag Status"
                            // status={{
                            //   expected: todayData[activeTab]?.expected?.bag,
                            //   arrived: todayData[activeTab]?.arrived?.bag,
                            //   inscanned: todayData[activeTab]?.inscanned?.bag,
                            //   outscanned: todayData[activeTab]?.outscanned?.bag,
                            //   pendingInscan:
                            //     todayData[activeTab]?.pendingInscan?.bag,
                            // }}
                            status={{
                              incoming: todayData[activeTab]?.bag_wise?.incoming,
                              inscan: todayData[activeTab]?.bag_wise?.inscan,
                              outscan: todayData[activeTab]?.bag_wise?.outscan,
                              pending: todayData[activeTab]?.bag_wise?.pending,
                            }}
                          />
                          {/* )} */}
                        </div>
                      </Spin>
                    </Col>
                  </Row>
                </Spin>
              )}
              <Row gutter={[32, 32]}>
                {dashboardMenuList.map((item, index) => {
                  if (
                    item?.role === "" ||
                    item.role.some((e) => accountDetails?.roles?.includes(e))
                  ) {
                    return (
                      <Col
                        xl={6}
                        lg={8}
                        md={10}
                        sm={12}
                        xs={12}
                        className="cash-booking"
                        key={index}
                      >
                        <DashbordCard
                          accountBookingArrowIcon={accountBookingArrowIcon}
                          accountBookingIcon={item.icon}
                          watchIcon={calenderIcon}
                          bookingType={item.title}
                          route={item.route}
                          id={item.id}
                        />
                      </Col>
                    );
                  }
                })}
              </Row>
            </Col>
            <Col xl={8} lg={8} md={24} sm={24} xs={24}>
              <div style={{ marginBottom: "20px" }}>
                <LiveTickets
                  config={{
                    env: process.env.REACT_APP_ENV || "dev",
                    limit: 3,
                  }}
                  onTicketClick={setSelectedTicket}
                />

                <TicketDetail
                  ticket={selectedTicket}
                  onClose={() => setSelectedTicket(null)}
                />
              </div>
              {dataSource.length > 0 && (
                <Row>
                  <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    <Card
                      size="small"
                      className="dashboard-container-card-div"
                      style={{ height: "380px", marginBottom: "20px" }}
                      title={
                        <div>
                          {" "}
                          <img
                            width="24px"
                            height="24px"
                            className="dashboard-container-card-div-icon"
                            src={dashboardAnnouncementIcone}
                          />
                          <span className="announcement-text">
                            {" "}
                            {ANNOUNCEMENT}{" "}
                          </span>
                        </div>
                      }
                    >
                      <List
                        itemLayout="horizontal"
                        dataSource={dataSource}
                        pagination={
                          dataSource.length > 3
                            ? {
                              pageSize: 3,
                            }
                            : false
                        }
                        renderItem={(item) => (
                          <List.Item
                            style={{ cursor: "pointer" }}
                            onClick={() => showAnnouncement(item)}
                          >
                            <List.Item.Meta
                              title={
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                  <div style={{ display: "flex", alignItems: "center", overflow: "hidden", flex: 1 }}>
                                    <img
                                      width="29px"
                                      height="29px"
                                      className="dashboard-container-card-div-messageIcon"
                                      src={dashbordMessageIcon}
                                      style={{ minWidth: "29px" }}
                                    />
                                    <span
                                      className="listTitle"
                                      style={{
                                        textTransform: "capitalize",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flex: 1,
                                        color:
                                          item.priorityType === "HIGH"
                                            ? "#C40000"
                                            : item.priorityType === "MEDIUM"
                                              ? "#DF8100"
                                              : "#179503",
                                      }}
                                      title={item.title}
                                    >
                                      {item.title}
                                    </span>
                                  </div>
                                  {getAttachmentUrl(item) && (
                                    <Tooltip title="View Attachment">
                                      <img
                                        width="30px"
                                        height="30px"
                                        style={{
                                          marginLeft: "10px",
                                          verticalAlign: "middle",
                                          cursor: "pointer"
                                        }}
                                        src={attachmentIcon}
                                        alt="attachment"
                                      />
                                    </Tooltip>
                                  )}
                                </div>
                              }
                              description={
                                <div>
                                  <span className="listDiscription">
                                    {item.validFrom + " - " + item.validTo}
                                  </span>
                                </div>
                              }
                            />
                          </List.Item>
                        )}
                      />
                    </Card>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Form>
      </Spin>
      <Modal
        title={selectedAnnouncement?.title}
        visible={isAnnouncementModalVisible}
        onCancel={() => setIsAnnouncementModalVisible(false)}
        footer={false}
        width={650}
        className="square-modal"
      >
        <div className="modal-content-wrapper">
          <div
            className="message-content"
            style={{ fontSize: "14px", lineHeight: "1.6" }}
            dangerouslySetInnerHTML={{ __html: cleanHtml(selectedAnnouncement?.message) }}
          ></div>
          {getAttachmentUrl(selectedAnnouncement) && (
            <div className="media-preview" style={{ textAlign: "center", background: "#f5f5f5", padding: "0 10px 10px 10px", borderRadius: "8px", display: "flex", flexDirection: "column", alignItems: "center" }}>
              {isVideo(getAttachmentUrl(selectedAnnouncement)) ? (
                <video
                  key={getAttachmentUrl(selectedAnnouncement)}
                  width="100%"
                  controls
                  autoPlay
                  muted
                  playsInline
                  src={getAttachmentUrl(selectedAnnouncement)}
                  style={{ borderRadius: "8px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}
                >
                  Your browser does not support the video tag.
                </video>
              ) : isImage(getAttachmentUrl(selectedAnnouncement)) ? (
                <img
                  src={getAttachmentUrl(selectedAnnouncement)}
                  alt="Attachment"
                  style={{ maxWidth: "100%", borderRadius: "8px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}
                />
              ) : isPdf(getAttachmentUrl(selectedAnnouncement)) ? (
                <iframe
                  src={getAttachmentUrl(selectedAnnouncement)}
                  width="100%"
                  height="400px"
                  style={{ border: "none", borderRadius: "8px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}
                  title="PDF Preview"
                >
                  Your browser does not support iframes.
                  <a href={getAttachmentUrl(selectedAnnouncement)} target="_blank" rel="noopener noreferrer">
                    View PDF
                  </a>
                </iframe>
              ) : (
                <div className="file-attachment">
                  <a href={getAttachmentUrl(selectedAnnouncement)} target="_blank" rel="noopener noreferrer">
                    View Attachment
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
}
Dashboard.propTypes = {
  data1: PropTypes.number,
};

export default Dashboard;

const CustomTabs = ({ activeTab, tabChange }) => {
  const tabStyles = (tab) => ({
    flex: 1,
    textAlign: "center",
    paddingLeft: "50px",
    color: activeTab === tab ? "#000" : "#a6a6a6",
    fontWeight: activeTab === tab ? "bold" : "normal",
    fontSize: "16px",
    cursor: "pointer",
    paddingBottom: "10px",
  });

  const indicatorStyles = (isPrimary) => ({
    position: "absolute",
    width: "50%",
    // height: "3px",
    height: "6px",
    borderBottomLeftRadius:
      activeTab === (isPrimary ? "cp" : "hub") ? "5px" : "0",
    borderBottomRightRadius:
      activeTab === (isPrimary ? "cp" : "hub") ? "0" : "5px",
    backgroundColor: isPrimary ? "#1890ff" : "#ABAFB1",
    bottom: 0,
    left: activeTab === (isPrimary ? "cp" : "hub") ? "10%" : "60%",
    transition: "left 0.6s ease-in-out, border-radius 0.6s ease-in-out",
  });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        paddingLeft: "10%",
        paddingTop: "30px",
        position: "relative",
      }}
    >
      <div onClick={() => tabChange("cp")} style={tabStyles("cp")}>
        CP
      </div>
      <div onClick={() => tabChange("hub")} style={tabStyles("hub")}>
        Hub
      </div>
      <div style={indicatorStyles(true)} />
      <div style={indicatorStyles(false)} />
    </div>
  );
};

const ShipmentStatusCompo = ({ array, styleObj }) => (
  <Row gutter={12} className="">
    {array?.map((item, i) => (
      <Col lg={6} md={6} sm={6} key={i}>
        <div
          className="shipmentStatusContainer"
          style={styleObj[item?.status]?.styles}
        >
          <div className="textNumber" style={styleObj[item?.status]?.textColor}>
            {item?.total_count}
          </div>
          <div>{capitalize(item?.status)}</div>
        </div>
      </Col>
    ))}
  </Row>
);

const StatusRow = ({ title, status }) => (
  <>
    <div className="pl-1" style={{ color: "#008000" }}>
      {title}
    </div>
    <div className="autoAdjust p-1">
      {/* <div>
        <StatusCard
          count={status.expected}
          label="Expected"
          style={cardStyles.expected}
        />
      </div> */}
      <div>
        <StatusCard
          count={status.incoming}
          label="Incoming"
          style={cardStyles.incoming}
        />
      </div>
      <div>
        <StatusCard
          count={status.inscan}
          label="Inscan"
          style={cardStyles.inscan}
        />
      </div>
      <div>
        <StatusCard
          count={status.outscan}
          label="Outscan"
          style={cardStyles.outscan}
        />
      </div>
      <div>
        <StatusCard
          count={status.pending}
          label="Pending"
          style={cardStyles.pending}
        />
      </div>
    </div>
  </>
);

const cardStyles = {
  incoming: {
    backgroundColor: "#CDDFFA",
    borderColor: "#1890FF",
    borderRadius: "10px",
  },
  inscan: {
    backgroundColor: "#F6FFED",
    borderColor: "#B7EB8F",
    borderRadius: "10px",
  },
  pending: {
    backgroundColor: "#FFF1F0",
    borderColor: "#FFA39E",
    borderRadius: "10px",
  },
  outscan: {
    backgroundColor: "#FFFBE6",
    borderColor: "#FFE58F",
    borderRadius: "10px",
  },
  pendingInscan: {
    backgroundColor: "#FFFBE6",
    borderColor: "#FFE58F",
    borderRadius: "10px",
  },
  pendingOutscan: {
    backgroundColor: "#FFFBE6",
    borderColor: "#FFE58F",
    borderRadius: "10px",
  },
};

const StatusCard = ({ count, label, style }) => (
  <Card bordered style={{ textAlign: "center", ...style }}>
    <div>{count ? count : 0}</div>
    <div>{label}</div>
  </Card>
);
